<template>
    <div>
        <!-- [ Modal form Save Task Tree ] start -->
        <sweet-modal blocking ref="projectExpenseModal" class="project-expense-modal" v-on:close="closeModal">
            <h1 v-if='!ifEdit' class="project-expense-modal__title">Add New Expense</h1>
            <h1 v-else class="project-expense-modal__title">Edit Expense</h1>
            <el-form :model="form" status-icon :rules="rules" ref="form" label-position="right" class="project-expense-modal__form">
                <div>
                    <div>
                        <el-col class="col" :span="12">
                            <el-form-item label-width="130px" v-if="ifEdit" label="Expense No.">
                                <el-input disabled v-model="codeNo" filterable size="mini" placeholder="Expense No.">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </div>
                    <el-row v-if="selectedRow">
                        <el-col :span="12">
                            <el-form-item label-width="130px" v-if="selectedRow.type === 'project' || selectedRow.type === 'Engagement'" prop="projectListName" :label="labelName">
                                <el-select disabled v-model="selectedRow.name" size="mini" :placeholder="labelName" style="width:100%">
                                    <el-option v-for="item in form.projectList"
                                               filterable
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label-width="130px" prop="projectListName" v-if="selectedRow.type === 'task' || selectedRow.type === 'Task' || selectedRow.type === 'masterTask'" label="Project">
                                <el-select disabled v-model="selectedProject.name" size="mini" placeholder="Task" style="width:100%">
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label-width="130px" prop="taskListName" v-if="selectedRow.type === 'task' || selectedRow.type === 'Task' || selectedRow.type === 'masterTask'" label="Task">
                                <el-select disabled v-model="selectedRow.name" size="mini" placeholder="Task" style="width:100%">
                                    <el-option v-for="item in form.taskList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label-width="130px" v-if="selectedRow.type === 'project' || selectedRow.type === 'Engagement'" prop="taskListId" label="Task">
                                <el-select v-model="form.taskListId" clearable size="mini" placeholder="Task" style="width:100%">
                                    <el-option v-for="item in form.taskList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setTaskId(item.id)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div>
                    <!--IF CREATE FROM EXPENSE-->
                    <el-row v-if="fromExpensePage === true">
                        <el-col :span="12">
                            <el-form-item label-width="130px" prop="projectListId" :label="labelName">
                                <el-select v-model="form.projectListId" size="mini" :placeholder="labelName" style="width:100%;">
                                    <el-option v-for="item in form.projectList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setProject(item.id, false, false, false, activeState)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label-width="130px" prop="taskListId" label="Task">
                                <el-select clearable :disabled="disabledTask" v-model="form.taskListId" size="mini" placeholder="Task" style="width:100%;">
                                    <el-option v-for="item in form.taskList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setTask(item.id, false, activeState)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!--IF EDIT FROM EXPENSE-->
                    <el-row v-if="ifEdit === true">
                        <el-col :span="12">
                            <el-form-item label-width="130px" prop="projectListIdEdit" label="Project">
                                <el-select disabled v-model="form.projectListIdEdit" size="mini" placeholder="Project" style="width:100%">
                                    <el-option v-for="item in form.projectList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setProject(item.id, false, false, false, activeState)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label-width="130px" prop="taskListIdEdit" label="Task">
                                <el-select  clearable v-model="form.taskListIdEdit" size="mini" placeholder="Task">
                                    <el-option v-for="item in form.taskList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setTask(item.id, false, activeState)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label-width="130px" prop="clientId" label="Client">
                            <el-select :disabled="disabledInputs" v-model="form.clientId" filterable size="mini" placeholder="Client" style="width:100%;">
                                <el-option
                                        v-for="item in form.clientList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label-width="130px" prop="vendorListInput" label="Vendor Name">
                            <el-autocomplete
                                    :disabled="disabledInputs"
                                    popper-class="my-autocomplete"
                                    v-model="form.vendorListInput"
                                    size="mini"
                                    :fetch-suggestions="querySearch"
                                    placeholder="Vendor Name"
                                    @select="handleSelect">
                                <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
                                <el-button
                                        class="add-btn"
                                        v-if="isEmpty"
                                        size="mini"
                                        type="primary"
                                        slot="append"
                                        pain
                                        @click="handleIconClickVendor">Add</el-button>
                                <template slot-scope="{ item }">
                                    <div class="value">{{ item.name }}</div>
                                </template>
                            </el-autocomplete>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label-width="130px" label="Expense Date" prop="date">
                            <el-date-picker
                                    format="d MMM yy"
                                    :disabled="disabledInputs"
                                    size="mini"
                                    v-model="form.date"
                                    type="date"
                                    placeholder="Pick a date"
                                    value-format="ddMMyyyy"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item  label-width="130px" prop="companyInventoryItemId" label="Item">
                            <el-select :disabled="disabledInputs" v-model="form.companyInventoryItemId" filterable size="mini" placeholder="Expense Item" style="width:100%;">
                                <el-option
                                        v-for="item in form.companyInventoryItem"
                                        :key="item.id"
                                        :label=" 'No.' + item.number + '  ' + item.name"
                                        :value="item.id"
                                        @click.native="handleSelectItem(item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label-width="130px" prop="vendorTaxNumber" label="Vendor Tax No.">
                            <el-input :disabled="disabledInputs" v-model="form.vendorTaxNumber" size="mini" placeholder="Vendor Tax Number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label-width="130px" prop="ifTax">
                            <el-radio-group @change="countModal(form.amount, taxObject, form.ifTax, form.qty, isWth, form.table.itemWhTax)" v-model="form.ifTax" style="display:block;">
                                <el-radio :disabled="disabledInputs" label="Tax Exclusive"></el-radio>
                                <el-radio :disabled="disabledInputs" class="inclusive-btn" label="Tax Inclusive" style="display:block;"></el-radio>
                            </el-radio-group>
                            <el-checkbox @change="countModal(form.amount, taxObject, form.ifTax, form.qty, isWth, form.table.itemWhTax)" v-model="isWth" :disabled="disabledInputs" label="Apply WHTax"></el-checkbox>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!--TABLE START -->
                Item
                <el-table
                        :key="tableKey"
                        size="small"
                        border
                        :data="[form]"
                        style="width: 100%">
                    <el-table-column
                            label="No."
                            width="60">
                        <template slot-scope="scope">
                            {{scope.row.table.itemNo}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Name"
                            width="130">
                        <template slot-scope="scope">
                            {{scope.row.table.itemName}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Unit Price">
                            <el-form-item prop="amount">
                                <el-input @mouseleave.native="countModal(form.amount, taxObject, form.ifTax, form.qty, isWth, form.table.itemWhTax)" @change="countModal(form.amount, taxObject, form.ifTax, form.qty, isWth, form.table.itemWhTax)" :disabled="disabledInputs" type="number" v-model="form.amount" size="mini"></el-input>
                            </el-form-item>
                    </el-table-column>
                    <el-table-column
                            label="Qty">
                        <el-form-item prop="qty">
                            <el-input @mouseleave.native="countModal(form.amount, taxObject, form.ifTax, form.qty, isWth, form.table.itemWhTax)" @change="countModal(form.amount, taxObject, form.ifTax, form.qty, isWth, form.table.itemWhTax)" :disabled="disabledInputs" type="number" v-model="form.qty" size="mini"></el-input>
                        </el-form-item>
                    </el-table-column>
                    <el-table-column
                            label="VAT exclusive">
                        <template slot-scope="scope">
                            <div v-if="form.ifTax === 'Tax Inclusive' && taxObject.value === 0">
                                {{formatPrice(scope.row.table.itemNetAmount)}}
                            </div>
                            <div v-else-if="form.ifTax === 'Tax Inclusive'">
                                {{formatPrice(includesTax)}}
                            </div>
                            <div v-if="form.ifTax === 'Tax Exclusive'">
                                {{formatPrice(scope.row.table.itemNetAmount)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Tax">
                        <el-form-item prop="taxId">
                            <el-select :disabled="disabledInputs" type="number" v-model="form.taxId" size="mini" placeholder="Tax">
                                <el-option
                                        v-for="item in form.taxList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="countModal(form.amount, item, form.ifTax, form.qty, isWth, form.table.itemWhTax)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-table-column>
                    <el-table-column
                            label="WHTax">
                        <template slot-scope="scope">
                            {{scope.row.table.itemWhTaxName}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Total">
                        <template slot-scope="scope">
                            {{scope.row.table.itemTotal}}
                        </template>
                    </el-table-column>
                </el-table>
                <!--TABLE END -->

                <el-row :span="24" :gutter="20">
                    <el-col :span="12" style="margin-top:18px;">
                        <el-form-item label-width="130px" label="Payment Method" >
                            <el-radio @change="clickOnPayment(ifDiff)" :disabled="disabledInputs" v-model="paymentMethodRadio" label="Payment">Payment</el-radio>
                            <el-radio :disabled="disabledInputs" v-model="paymentMethodRadio" label="CA">Cash Advance</el-radio>
                        </el-form-item>
                        <div v-if="paymentMethodRadio === 'CA'">
                            <el-form-item  label-width="130px"  prop="cashAdvanceId" label="Cash Advance">
                                <el-select :disabled="disabledInputs"  type="number" v-model="form.cashAdvanceId" size="mini" placeholder="Cash Advance">
                                    <el-option
                                            v-for="item in form.cashAdvanceList"
                                            :key="item.id"
                                            :label="item.code + '   ' + formatPrice(item.amount)"
                                            @click.native="selectCashAdvance(item)"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item   label-width="130px" label="Balance">
                                <el-button  plain size="mini" :type="typeOfBallance" >{{formatPrice(totalBalance)}}</el-button>
                            </el-form-item>
                        </div>
                        <div v-else>
                            <el-form-item  label-width="130px" prop="paymentMethodId" label="Payment">
                                <el-select :disabled="disabledInputs" v-model="form.paymentMethodId" size="mini" placeholder="Payment Method">
                                    <el-option
                                            v-for="item in form.paymentMethodList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <el-form-item label-width="130px" prop="reimbursable">
                            <el-checkbox :disabled="disabledInputs || ifReambursable" name="type" v-model="form.reimbursable">Reimbursable</el-checkbox>
                        </el-form-item>
                        <el-form-item label-width="130px" prop="billable">
                            <el-checkbox :disabled="disabledInputs" name="type" v-model="form.billable">Billable</el-checkbox>
                        </el-form-item>
                        <el-form-item label-width="130px" prop="groupTripName" label="Group / Trip Name">
                            <el-input :disabled="disabledInputs" v-model="form.groupTripName" size="mini" placeholder="Group / Trip Name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <div class="bill">
                            <h4 v-if="form.ifTax === 'Tax Exclusive'"><span>Subtotal</span><span>{{formatPrice(form.table.itemNetAmount || form.amount)}}</span></h4>
                            <h4 v-if="form.ifTax === 'Tax Exclusive'"><span>+ Tax of</span><span>{{formatPrice(taxOf)}}</span></h4>
                            <h4 v-if="form.ifTax === 'Tax Inclusive'"><span>Includes Tax of</span><span>{{formatPrice(icludesTaxOf)}}</span></h4>
                            <h4><span>Total Amount</span><span>{{formatPrice(totalAmaunt)}}</span> </h4>
                            <h4 v-if="isWth"><span>WHTax Amount</span><span>{{formatPrice(whtTaxAmount)}}</span></h4>
                            <el-divider></el-divider>
                            <div class="payment-to-vendor">
                                <h3><span>Payment to Vendor</span><span>{{formatPrice(paymentToVendorAmount)}}</span></h3>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="Notes" prop="notes">
                        <el-input :disabled="disabledInputs" type="textarea" v-model="form.notes"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>

                </el-row>
                <el-row>
                    <addFileToExpence :fileListEdit="fileListEdit" :disabledInputs="disabledInputs" ref="addFileToExpence" :selectedRow="selectedRow" @nestedChildOpen="nestedChildOpen" @putFileIntoFormArray="putFileIntoFormArray" @removeFile="removeFile" />
                </el-row>
                <div class="project-expense-modal__btn">
                    <el-button v-if="ifEdit === false" :disabled="disabledInputs" @click="submitForm('form', activeState)" type="primary" plain size="mini">Save</el-button>
                    <el-button v-else :disabled="disabledInputs" @click="submitFormEdit('form', activeState)" type="primary" plain size="mini">Edit</el-button>
                </div>

                <!--<div>-->
                    <!--лишнее-->

                    <!--<el-row :gutter="20" :span="24">-->
                        <!--<el-col :span="6">-->

                        <!--</el-col>-->
                        <!--<el-col :span="6">-->
                            <!--<el-form-item   label-position="top" prop="amount" label="Amount">-->
                                <!--<el-input @mouseleave.native="countModal(form.amount, taxObject, form.ifTax, form.qty, isWth, form.table.itemWhTax)" @change="countModal(form.amount, taxObject, form.ifTax, form.qty, isWth, form.table.itemWhTax)" :disabled="disabledInputs" type="number" v-model="form.amount" size="mini" placeholder="Amount"></el-input>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                        <!--<el-col :span="4">-->
                            <!--<el-form-item label-position="top" label="VAT">-->
                                <!--<el-button  plain size="mini" type="primary" >{{formatPrice(taxOf)}}</el-button>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                        <!--<el-col :span="3">-->
                            <!--<el-form-item label-position="top" label="WTX">-->
                                <!--<el-button  plain size="mini" type="primary" >{{formatPrice(whtAmount)}}</el-button>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                        <!--<el-col :span="5">-->
                            <!--<el-form-item label-position="top" label="Total Amount">-->
                                <!--<el-button  plain size="mini" type="primary" >{{formatPrice(totalAmaunt)}}</el-button>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                    <!--</el-row>-->

                    <!--<el-col :span="12">-->
                        <!--<div>-->

                        <!--</div>-->
                    <!--</el-col>-->
                    <!--<el-row>-->
                        <!--<el-col :span="12">-->
                            <!--<el-form-item label-width="130px" prop="taxId" label="Tax">-->
                                <!--<el-select :disabled="disabledInputs" type="number" v-model="form.taxId" size="mini" placeholder="Tax">-->
                                    <!--<el-option-->
                                            <!--v-for="item in form.taxList"-->
                                            <!--:key="item.id"-->
                                            <!--:label="item.name"-->
                                            <!--:value="item.id"-->
                                            <!--@click.native="countModal(form.amount, item, form.ifTax, form.qty, isWth, form.table.itemWhTax)">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                <!--</div>-->
                <!--{{includesTax}}-->
            </el-form>
        </sweet-modal>
        <AddVendorForm ref="modal11" :directories="directories" v-model="form.vendorListInput" @setTask="setTask"/>
    </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'
  let moment = require('moment')
  import addFileToExpence from '@/components/Projects/addFileToExpence.vue'
  import AddVendorForm from '@/components/vendors/AddVendorForm.vue'

  export default {
    components: {
      SweetModal,

      addFileToExpence,
      AddVendorForm
    },
    props: ['projectExpenseModal', 'selectedRow', 'valueProject', 'projectName'],
    data() {
      return {
        tableKey:0,
        // Table
        // tableData:[
        //   {
        //     itemNo:'',
        //     itemName: ''
        //   }
        // ],
        paymentMethodRadio: 'Payment',
        codeNo: '',
        totalAmaunt: '0',
        whtTaxAmount: '0',
        whtAmount: '0',
        paymentToVendorAmount: '0',
        includesTax:'0',
        icludesTaxOf:'0',
        totalBalance: '0',
        nativeAmount: '',
        isNativeSelected: false,
        selectedItem:{},
        taxObject: '',
        taxOf: '',
        taxAmount: '',
        projectTaxId: '',
        selectedTaskId: '',
        isEmpty:false,
        ifEdit:false,
        isWth: false,
        typeOfBallance: 'primary',
        ifReambursable: false,
        ifDiff: false,
        selectedProjectId: '',
        disabledInputs:true,
        disabledTask:true,
        moment:moment,
        projectTaskExpenseId: '',
        countingAmount: false,
        selectedProject: {},
        form: {
          projectListIdEdit:'',
          projectListId:this.selectedRow.name,
          projectList:[],
          taskListIdEdit: '',
          taskListId: '',
          taskList: [],
          companyInventoryItemId: '',
          // companyInventoryItemName: '',
          companyInventoryItem: [],
          vendorList: [],
          vendorListInput: '',
          vendorListId: '',
          date:'',
          paymentMethodId: '',
          paymentMethodList: [],
          amount: '',
          qty:'',
          // amountId: '',
          // amountList: [],
          taxId: '',
          taxList:[],
          reimbursable: false,
          billable: false,
          // isCashAdvance: false,
          cashAdvanceList:[],
          cashAdvanceId:'',
          ifTax: 'Tax Exclusive',
          clientId: '',
          clientList: [],
          vendorTaxNumber: '',
          groupTripName: '',
          notes: '',
          fileId: null,
          // tableData
          table:{
            itemNo:'',
            itemName: '',
            itemWhTax: '',
            itemWhTaxName:'',
            itemNetAmount: '',
            itemTotal: ''
          }
        },
        directories:null,
        fromExpensePage:false,
        fileUrl: '',
        fileListEdit:[],
        links: [],
        // state: '',
        rules: {
            companyInventoryItemId: [{
            required: true,
            message: 'Field is required',
            trigger: 'blur'
          }],
          amount: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          qty: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          taxId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          vendorListInput: [
            { required: true,
              message: 'Field is required',
              trigger: 'change' }
          ],
          date: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          paymentMethodId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          // taskListId: [
          //   { required: true,
          //     message: 'Field is required',
          //     trigger: 'blur' }
          // ],
          clientId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          cashAdvanceId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          // vendorTaxNumber:[
          //   { required: true,
          //     message: 'Field is required',
          //     trigger: 'blur' }
          // ],
          // groupTripName:[
          //   { required: true,
          //     message: 'Field is required',
          //     trigger: 'blur' }
          // ],
          notes:[
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          projectListId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ]
        },
        activeState:'',
        labelName: ''
      }
    },
    computed:{
      item() {
        return this.form.companyInventoryItemId;
      }
    },
    // mounted(){
    //   this.links = this.loadAll();
    // },
    methods: {
      setTaskId(taskId){
        this.selectedTaskId = taskId
      },
      getCurrency(){
        // let _axios = axios
        // _axios.defaults.headers.common = 0;
        // _axios
        //   .get(`https://free.currconv.com/api/v7/currencies?apiKey=16efddfda704e39960f0`).then(response => {
        //   this.form.amountList = response.data.results
        //   _axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        //   _axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // }).catch(error => {
        //   console.log('An error occurred:', error);
        //   loader.hide()
        // })

      },
      //HANDLE SELECT CA
      selectCashAdvance(item){
        // const item = this.findCashAdvance(id, this.form.cashAdvanceList)
        this.totalBalance = item.dif || '0'
        const diff = this.countTotalBalance(Number(this.totalAmaunt), item.dif)
        console.log('diff', diff)
      },
      // COUNT TOTAL BALANCE LESS/OR MORE
      countTotalBalance(totalAmount, totalBalance){
        console.log('totalAmount', totalAmount)
        console.log('totalBalance', totalBalance)
        const diff = totalBalance < totalAmount
        if(diff){
          this.ifReambursable = true
          this.form.reimbursable = true
          this.typeOfBallance = 'danger'
        }else {
          this.ifReambursable = false
          this.form.reimbursable = false
          this.typeOfBallance = 'primary'
        }
        this.ifDiff = diff
        return diff
      },
      putFileIntoFormArray(fileId){
        // this.form.fileId.push(fileId)
        this.form.fileId = fileId
      },
      clickOnPayment(ifDiff){
        if(ifDiff){
          this.ifReambursable = false
          this.form.reimbursable = false
          this.typeOfBallance = 'primary'
          this.form.cashAdvanceId = ''
          this.totalBalance = '0'
        }
      },
      openModalFromExpense(state){
        const urlParts = this.buildUrl(state)
        this.activeState = state
        this.labelName = urlParts.labelName
        this.ifEdit = false
        this.fromExpensePage = true
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.routeName}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.form.projectList = response.data.list
            this.$refs.projectExpenseModal.open()
          }).catch(error =>{
            console.log(error)
        })
      },
      openModalFromExpenseEdit(selectedRow, state){

        this.activeState = state
        const urlParts = this.buildUrl(state)
        // console.log('const urlParts', urlParts)
        this.labelName = urlParts.labelName

        this.ifEdit = true
        this.disabledInputs = false

        // console.log(selectedRow)

        // PROJECT ACTIVE
        if(state === 'projectTaskExpenses'){
          this.selectedProjectId = selectedRow.projectId
          this.form.projectListIdEdit = selectedRow.project.name

          if(!selectedRow.projectTaskId){
            this.form.taskListIdEdit = ''
          }else{
            this.form.taskListIdEdit = selectedRow.projectTaskId
          }
        }
        // ENGAGEMENT ACTIVE
        else if (state === 'engagementTaskExpenses'){
          this.selectedProjectId = selectedRow.engagementId
          this.form.projectListIdEdit = selectedRow.engagement.name

          if(!selectedRow.engagementTaskId){
            this.form.taskListIdEdit = ''
          }else{
            this.form.taskListIdEdit = selectedRow.engagementTaskId
          }
        }
        // BU ACTIVE
        else if (state === 'businessUnitTaskExpenses'){
          this.selectedProjectId = selectedRow.businessUnitId
          this.form.projectListIdEdit = selectedRow.businessUnit.name

          if(!selectedRow.businessUnitTaskId){
            this.form.taskListIdEdit = ''
          }else{
            this.form.taskListIdEdit = selectedRow.businessUnitTaskId
          }
        }
        console.log('projectId, projectTaskId, expenseId, operation, state', selectedRow.engagementId, selectedRow.engagementTaskId, selectedRow.id)

        this.setProject(selectedRow.projectId || selectedRow.engagementId || selectedRow.businessUnitId,
                        selectedRow.projectTaskId || selectedRow.engagementTaskId || selectedRow.businessUnitTaskId,
                        selectedRow.id,
                        'update', state)
        // this.setTask(selectedRow.projectTaskId)
        this.$refs.projectExpenseModal.open()
      },
      find(array, value) {
        console.log(array, value)
        for (var i = 0; i < array.length; i++) {
          console.log(array[i].id + '/' + value)
          if (array[i].id == value) return true;
        }
        return false
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      setProject(projectId, projectTaskId, expenseId, operation, state){
        if(!projectTaskId) projectTaskId = '0'
        const urlParts = this.buildUrl(state)
        this.selectedProjectId = projectId
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.stateProjectTasks}/list?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
          .then(response => {
            // if(response.data.list.length !== 0){
            //   this.disabledTask = false
            //   var index = this.find(response.data.list, this.form.taskListId);
            //   if(!index){
            //     this.form.taskListId = ''
            //   }
            // }else{
            //   this.disabledTask = true
            //   this.disabledInputs = true
            //   this.$refs['form'].resetFields();
            //   this.notification("Notification", "Project without tasks", "info")
            // }
            if(operation === 'update'){
              this.setTask('0', false, this.activeState).then(data => {
                if (data === 'done') this.getItem(projectId, projectTaskId, expenseId, this.activeState)
              })
            }else{
              this.setTask('0', false, this.activeState)
            }
            this.disabledTask = false
            var index = this.find(response.data.list, this.form.taskListId);
              if(!index){
                this.form.taskListId = ''
              }
            this.form.taskList = response.data.list
          }).catch(error =>{

        })
      },
      getDirectories(){

      },
      setTask(id, newVendor, state){
        const urlParts = this.buildUrl(state)
        return new Promise ((resolve, revect) =>{
          if(newVendor){
            this.isEmpty = false
            this.form.vendorListInput = newVendor.name
            this.form.vendorListId = newVendor.id
          }
          this.selectedTaskId = id
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${urlParts.state}/directories?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.selectedProjectId || this.$route.query.projectId}&${urlParts.stateTaskId}=${id || this.$route.query.projecTaskId}&operation=create`)
            .then(response => {
              this.form.paymentMethodList = response.data.projectTaskExpensePaymentMethod
              this.form.companyInventoryItem = response.data.companyInventoryItem
              this.form.clientList = response.data.companyClientList
              // this.form.vendorList = response.data.companyVendorList
              this.form.taxList = response.data.projectTaxList
              this.form.cashAdvanceList = response.data.projectTaskCashAdvance
              this.links = response.data.companyVendorList
              this.disabledInputs = false
              loader.hide()
              resolve('done')
            }).catch(error =>{
            loader.hide()
          })
        })
      },
      getItem(projectId, projectTaskId, projectTaskExpenseId, state){
        const urlParts = this.buildUrl(state)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.state}/item?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}&${urlParts.stateTaskId}=${projectTaskId}&${urlParts.stateExpenseId}=${projectTaskExpenseId}`)
          .then(response => {
            this.projectTaskExpenseId = response.data.item.id
            let date = response.data.item.expenseDate.toString()
            if (date.length < 8) {
              date = '0' + date
            }

            //CHECK PAYMENT METHOD
            if(response.data.item.projectTaskCashAdvanceId !== null){
              this.paymentMethodRadio = 'CA'
              this.form.cashAdvanceId = response.data.item.projectTaskCashAdvanceId
            }else if (response.data.item.projectTaskExpensePaymentMethodId !== null){
              this.paymentMethodRadio = 'Payment'
              this.form.paymentMethodId = response.data.item.projectTaskExpensePaymentMethodId
            }

            if(response.data.item.reimbursable === 1){
              this.form.reimbursable = true
            }else if(response.data.item.reimbursable === 1){
              this.form.reimbursable = false
            }
            if(response.data.item.isBillable === 1){
              this.form.billable = true
            }else if(response.data.item.isBillable === 1){
              this.form.billable = false
            }
            if(response.data.item.includeTax === 0){
              this.form.ifTax = 'Tax Exclusive'
            }else if(response.data.item.includeTax === 0){
              this.form.ifTax = 'Tax Inclusive'
            }
              // this.form.projectListId = response.data.item.projectId
              this.form.taskListId = response.data.item.projectTaskId
              this.form.companyInventoryItemId = response.data.item.projectTaskExpenseInventoryItemId
              this.form.paymentMethodId = response.data.item.projectTaskExpensePaymentMethodId
              this.form.vendorListId = response.data.item.companyVendorId
              console.log('links', this.links)
              this.links.forEach(val => {
                if(val.id === this.form.vendorListId){
                this.form.vendorListInput = val.name
              }
              })
              this.form.clientId = response.data.item.companyClientId
              this.form.date = date
              this.form.amount = response.data.item.amount
              this.totalAmaunt = response.data.item.totalAmount
              this.taxOf = response.data.item.taxAmount
              this.form.taxId = response.data.item.projectTaxId
              // this.form.ifTax = response.data.item.includeTax
              // this.form.reimbursable = response.data.item.reimbursable
              this.form.vendorTaxNumber = response.data.item.vendorTaxNo
              this.form.groupTripName = response.data.item.group
              this.form.notes = response.data.item.notes
              // this.form.billable = response.data.item.isBillable
              this.form.fileId = response.data.item.fileId
              this.codeNo = response.data.item.code
              console.log('form.vendorList', this.links)
              this.form.vendorList.forEach(val => {
              if(val.id == response.data.item.companyVendorId){
                this.form.vendorListInput = val.name
              }
              })
            // this.getTotalAmount(this.form.taxId, this.form.amount)
            if(response.data.item){
              let newFileItem = {
                id: '',
                name: '',
                url: ''
              }
              newFileItem.id = response.data.item.file.id
              newFileItem.name = response.data.item.file.baseName
              newFileItem.url = response.data.item.file.url
              this.fileListEdit.push(newFileItem)
            }

          }).catch(error =>{

        })
      },
      querySearch(queryString, cb) {
        console.log(queryString, {cb})
        var links = this.links;
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        // call callback function to return suggestion objects
        console.log(results)

        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if(results.length < 1){
            this.isEmpty = true
            this.form.vendorListId = ''
          }else{
            this.isEmpty = false
          }
          results.forEach(val => {
            if(val.name !== queryString){
              this.isEmpty = true
            }else if(val.name == queryString){
              this.isEmpty = false
            }
          })
          if(this.form.vendorListInput === ''){
            this.isEmpty = false
          }
          console.log('results', results)
          cb(results);
        }, 500 * Math.random());
      },
      querySearchItem(queryString, cb) {
        var links = this.form.companyInventoryItem;
        var results = queryString ? links.filter(this.createFilterItem(queryString)) : links;
        // call callback function to return suggestion objects
        cb(results);
      },
      createFilterItem(queryString) {
        return (link) => {
          console.log(link)
          return (link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelectItem(item) {
        this.selectedItem = item
        // this.form.companyInventoryItemId = item.id
        // this.form.companyInventoryItemName = item.name


        //put number into table
        this.form.table.itemNo = item.number
        //put name into table
        this.form.table.itemName = item.name
        //if buyingPrice Selected in Item
        if(item.buyPrice){
          this.nativeAmount = item.buyPrice
          this.isNativeSelected = true
          this.form.amount = item.buyPrice
        }else{
          this.form.amount = ''
          this.nativeAmount = ''
          this.isNativeSelected = false
        }
        this.tableKey =+ 1
        //check if buyerProjectTax selected
        //check if withholding tax
        if(item.buyerProjectTax){
          // set taxId value in table
          this.form.taxId = item.buyerProjectTax.id
          this.taxObject = item.buyerProjectTax
        }else{
          // set taxId value in table
          this.form.taxId = ''
          this.taxObject = ''
        }

        //check if withholding tax
        if(item.buyerWithholdingTax){
          this.isWth = true
          // set WHTax value in table
          this.form.table.itemWhTax = item.buyerWithholdingTax.value
          this.form.table.itemWhTaxName = item.buyerWithholdingTax.name
        }else{
          // set WHTax value in table
          this.form.table.itemWhTax = 0
          this.form.table.itemWhTaxName = ''
          this.isWth = false
        }
        // if paste amount and withholdingtax present
        if(item.buyerWithholdingTax && this.form.amount){
          this.getVatAmount(item.buyerWithholdingTax.value, this.form.amount)
        }
        console.log(item);
        this.countModal(this.form.amount, this.taxObject, this.form.ifTax, this.form.qty, this.isWth, this.form.table.itemWhTax)
      },
      createFilter(queryString) {
        return (link) => {
          return (link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      loadAll() {
        return [
          { "value": "vue"},
          { "value": "element" },
          { "value": "cooking" },
          { "value": "mint-ui" },
          { "value": "vuex" },
          { "value": "vue-router" },
          { "value": "babel" }
        ];
      },
      handleSelect(item) {
        this.form.vendorListInput = item.name
        this.form.vendorListId = item.id
        this.isEmpty = false
        console.log(item);
      },
      handleIconClickVendor(ev) {
        console.log(ev);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=create`)
          .then(response => {
            console.log('---/companyVendors/directories', response.data);
            this.$refs['modal11'].$refs['addVendorForm'].open()
            this.$refs['modal11'].selectedTaskId = this.selectedTaskId
            this.directories = response.data
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      // turnOffCashAdvance(){
      //   this.form.isCashAdvance = false
      //   this.form.cashAdvanceId = ''
      // },
      // turnOnCashAdvance(){
      //   this.form.reimbursable = false
      //   this.form.billable = false
      // },
      async countModal(taxAmount, taxObject, ifTax, qty, isWth, wthAmount){
        if(Number(taxObject.value) === 0) this.includesTax = 0
        try {
          console.log('11 taxAmount', taxAmount, 'taxObject', taxObject, 'ifTax',ifTax, 'qty', qty, 'isWth', isWth, 'wthAmount', wthAmount)
          this.taxObject = taxObject

          // COUNT TOTAL AMOUNT
          const totalAmount = await this.getTotalAmount(Number(taxAmount), taxObject, ifTax, Number(qty))
          console.log('countModal totalAmount', totalAmount)

          // COUNT NET AMOUNT
          const netAmount = await this.getNetAmount(Number(taxAmount), Number(qty), taxObject.value)
          console.log('countModal netAmount', netAmount)

          //CHECK IF TAX SELECTED
          if(taxObject){
            //COUNT TOTAL TAX
              const taxOf = await this.getTaxAmount(Number(taxObject.value), Number(netAmount) || Number(taxAmount))
              console.log('taxOf', taxOf)
          }

          //CHECK IF TAX INCLUSIVE
          if(ifTax === 'Tax Inclusive'){
            //COUNT INCLUDES TAX OF
            const includesTaxOf = await this.getIcludesTaxAmount(Number(taxObject.value), Number(netAmount) || Number(taxAmount))
            console.log('includesTaxOf', includesTaxOf)
          }

          //CHECK IF WITHHOLDING TAX CHECKBOX SELECTED
          if(isWth){
            //COUNT WTH AMOUNT
            let countedWthAmount = ''
            switch(ifTax){
              case 'Tax Inclusive':
                //IF INCLUDES OF TAX
                console.log('this.includesTax', this.includesTax)
                if(Number(this.includesTax) === 0){
                  countedWthAmount = await this.getWthAmount(Number(netAmount) , Number(wthAmount));
                  console.log('countedWthAmount INCLUSIVE if wth included', countedWthAmount, wthAmount)
                }else{
                  countedWthAmount = await this.getWthAmount(Number(this.includesTax) , Number(wthAmount));
                  console.log('countedWthAmount INCLUSIVE if wth included', countedWthAmount, wthAmount)
                }
              break;
              case 'Tax Exclusive':
                countedWthAmount = await this.getWthAmount(Number(netAmount) , Number(wthAmount));
                console.log('countedWthAmount EXCLUSIVE', countedWthAmount)
              break;
            }
            //COUNT PAYMENT TO VENDOR
            const paymentToVendorWithWth = await this.getPaymentToVendor(Number(totalAmount) , Number(countedWthAmount));
            console.log('paymentToVendorWithWth', paymentToVendorWithWth)
          }else{
            let countedWthAmount = ''
            switch(ifTax){
              case 'Tax Inclusive':
                countedWthAmount = await this.getWthAmount(Number(this.includesTax) , Number(wthAmount));
                console.log('countedWthAmount INCLUSIVE', countedWthAmount)
                break;
              case 'Tax Exclusive':
                countedWthAmount = await this.getWthAmount(Number(netAmount) , 0);
                console.log('countedWthAmount EXCLUSIVE', countedWthAmount)
                break;
            }
            //COUNT PAYMENT TO VENDOR
            const paymentToVendorWithWth = await this.getPaymentToVendor(Number(totalAmount) , 0);
            console.log('paymentToVendorWithWth', paymentToVendorWithWth)
          }

          // CHECK IF SELECT CA
          if(this.paymentMethodRadio === 'CA' && this.form.cashAdvanceId){
            //COUNT DIFFERENCE
            const ifBig = await this.countTotalBalance(Number(this.totalAmaunt) || 0, this.totalBalance)
            console.log('countModal ifBig', ifBig)
          }
        }catch (err){
          console.log(err)
        }

        //clear fields if Unit Price, Qty not selected
        if(!taxAmount || !qty || taxAmount <= 0 || qty <= 0){
          this.form.table.itemNetAmount = ''
          this.form.table.itemTotal = ''

        }
        console.log('end of function')
      },
      // COUNT TOTAL AMOUNT
      getTotalAmount(taxAmount, taxObject, ifTax, qty){
        console.log('taxAmount, taxObject, ifTax', taxAmount, taxObject, ifTax, qty)
        return new Promise ((resolve, reject) => {
          // console.log('projectTaxId', projectTaxId, 'taxAmount', taxAmount, 'taxObject', taxObject)
          if(!taxAmount){
            this.totalAmaunt = 0
            this.taxOf = 0
            resolve('no tax amount')
            return
          }else if(!taxObject){
            this.totalAmaunt = taxAmount
            resolve('no selected tax')
            return
          }else if(!qty){
            this.totalAmaunt = taxAmount
            resolve('no qty')
            return
          }
          // //SAVE TAX VALUE
          // if(taxObject){
          //   this.taxObject = taxObject
          // }
          // if(this.taxObject){
          //   this.taxOf = this.getTaxAmount(this.taxObject.value, taxAmount)
          //   console.log(this.taxOf)
          // }
          // this.countingAmount = true
          // if(!projectTaxId && !taxAmount && !taxObject){
          //   this.countingAmount = false
          //   this.totalAmaunt = '0'
          //   this.taxOf = '0'
          //   return
          // }
          // if(projectTaxId){
          //   this.projectTaxId = projectTaxId
          // }else if(!projectTaxId){
          //   this.totalAmaunt = taxAmount
          //   this.countingAmount = false
          //   return
          // }
          // if(taxAmount.toString()){
          //   this.taxAmount = taxAmount
          // }else if (!taxAmount){
          //   this.taxAmount = '0'
          //   this.countingAmount = false
          //   return
          // }
          const data = {
            projectTaxId: taxObject.id,
            amount: taxAmount * qty,
            includeTax: ifTax === 'Tax Inclusive'
          }
          // if(this.form.ifTax === 'Tax Inclusive'){
          //   data.includeTax = true
          // }else{
          //   data.includeTax = false
          // }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/projectTaskExpenses/getTotalAmount?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId || this.selectedProjectId || this.$route.query.engagementId}&projectTaskId=${this.selectedRow.id || this.selectedTaskId || 0}`, data)
            .then(response => {
              console.log('---/projectTaskExpenses/directories', response.data);
              // this.countingAmount = false
              function roundUp(num, precision) {
                precision = Math.pow(100, precision)
                return Math.ceil(num * precision) / precision
              }
              this.totalAmaunt = roundUp(response.data.totalAmount, 1)
              this.form.table.itemTotal = roundUp(response.data.totalAmount, 1)
              resolve(this.totalAmaunt)
            })
            .catch(error => {
              // this.countingAmount = false
              reject(error)
              console.log('An error occurred:', error);
            });
        });
      },
      // COUNT TAX AMOUNT
      getTaxAmount(percentages, taxAmount){
        console.log('percentages', percentages, 'taxAmount', taxAmount)
        return new Promise ((resolve, reject) => {
          if(percentages && taxAmount){
            this.taxOf = (Number(taxAmount)/100)*Number(percentages)
            resolve(this.taxOf)
          }else {
            this.taxOf = 0
            resolve(this.taxOf)
          }
        })
      },
      // COUNT INCLUDES TAX AMOUNT
      getIcludesTaxAmount(percentages, taxAmount){
        console.log('percentages icludes', percentages, 'taxAmount includes of', taxAmount)
        return new Promise ((resolve, reject) => {
          if(percentages && taxAmount){
            // TODO MUST FIX
              // let x = '';
              // x + (x * percentages) / taxAmount == taxAmount;
              // taxAmount * x + x * percentages == taxAmount * taxAmount;
              // (taxAmount + percentages) * x == taxAmount * taxAmount;
              // x = (taxAmount * taxAmount) / (taxAmount + percentages);
              // console.log('x', x)
            if(percentages.toString().length < 2){
              percentages = '1.0' + percentages.toString()
              console.log('1.0...', Number(percentages))
            }else{
              percentages = '1.' + percentages.toString()
              console.log('1.', Number(percentages))
            }
            this.includesTax = taxAmount / Number(percentages)
            this.icludesTaxOf = taxAmount - taxAmount / Number(percentages)
            console.log('this.icludesTaxOf', this.icludesTaxOf)
            resolve(this.icludesTaxOf)
          }else {
            this.icludesTaxOf = 0
            resolve(this.icludesTaxOf)
          }
        })
      },
      // COUNT VAT AMOUNT
      getVatAmount(percentages, taxAmount){
        console.log('percentages', percentages, 'taxAmount', taxAmount)
        return new Promise ((resolve, reject) => {
          if(percentages && taxAmount){
            this.whtAmount = (Number(taxAmount)/100)*Number(percentages)
            resolve(this.whtAmount)
          }else {
            this.whtAmount = 0
            resolve(this.whtAmount)
          }
        })
      },
      // COUNT NET AMOUNT
      getNetAmount(unitPrice, qty, taxValue){
        console.log('unitPrice', unitPrice, 'qty', qty, 'taxValue', taxValue)
        return new Promise ((resolve, reject) => {
          if(!unitPrice){
            resolve('no tax unitPrice')
            return
          }else if(!qty){
            this.form.table.itemNetAmount = unitPrice
            resolve('no selected qty')
            return
          }
          // if(unitPrice && qty && taxValue){
          //   this.form.table.itemNetAmount = (unitPrice * qty) + ((unitPrice * qty / 100) * taxValue);
          //   resolve(unitPrice * qty)
          //   alert(unitPrice * qty)
          // }else
            if(unitPrice && qty){
            this.form.table.itemNetAmount = unitPrice * qty
            resolve(this.form.table.itemNetAmount)
          }else {
            this.form.table.itemNetAmount = unitPrice
            resolve(this.form.table.itemNetAmount)
          }
        })
      },
      // COUNT WTHTax AMOUNT
      getWthAmount(unitPriceOrNet, wthAmount){
        console.log('unitPriceOrNet', unitPriceOrNet, 'wthAmount', wthAmount)
        return new Promise ((resolve, reject) => {
          if(!unitPriceOrNet){
            resolve('no tax unitPriceOrNet')
            return
          }else if(wthAmount === 0){
            this.whtTaxAmount = 0
            resolve(this.whtTaxAmount)
            return
          }else if(!wthAmount){
            resolve('no withholding tax')
          }
          if(unitPriceOrNet && wthAmount){
            this.whtTaxAmount = unitPriceOrNet / 100 * wthAmount
            console.log('this.whtTaxAmount', this.whtTaxAmount)
            resolve(this.whtTaxAmount)
          }else {
            this.whtTaxAmount = 0
            resolve(this.whtTaxAmount)
          }
        })
      },
      getWthAmountTaxIncl(icludesOfTax, wthAmount){
        console.log('unitPriceOrNet', icludesOfTax, 'wthAmount', wthAmount)
        return new Promise ((resolve, reject) => {
            if(icludesOfTax === 0){
              alert('hello world')
            }
        })
      },

      // COUNT PAYMENT TO VENDOR
      getPaymentToVendor(totalAmount, wthTaxAmount){
        console.log('totalAmount', totalAmount, 'wthTaxAmount', wthTaxAmount)
        return new Promise ((resolve, reject) => {
          if(totalAmount && wthTaxAmount){
            this.paymentToVendorAmount = totalAmount - wthTaxAmount
            resolve(this.paymentToVendorAmount)
          }else if(totalAmount && !wthTaxAmount){
            // alert('here')
            this.paymentToVendorAmount = totalAmount
          }else{
            // alert('here 2')
            this.paymentToVendorAmount = 0
            resolve(this.paymentToVendorAmount)
          }
        })
      },


      selectItem(expenseItem){
        if(expenseItem.buyerWithholdingTax){
          this.isWth = true
        }else{
          this.isWth = false
        }
        if(expenseItem.buyerWithholdingTax && this.form.amount){
          this.getVatAmount(expenseItem.buyerWithholdingTax.value, this.form.amount)
            // alert('hello')
        }
      },
      closeModal() {
          this.$refs['addFileToExpence'].fileList = []
          this.$refs['form'].resetFields();
          this.codeNo = ''
          this.selectedProject = {}
          this.isWth = false
          //table data
          this.form.table.itemNo = '';
          this.form.table.itemName = '';
          this.form.table.itemWhTax = '';
          this.form.table.itemWhTaxName ='';
          this.form.table.itemNetAmount = '';
          this.form.table.itemTotal = '';

          this.includesTax = '0'
          this.paymentMethodRadio = 'Payment'
          this.totalBalance = '0'
          this.taxOf = ''
          this.icludesTaxOf = '0'
          this.totalAmaunt = '0'
          this.whtTaxAmount = '0'
          this.paymentToVendorAmount = '0'
          this.selectedItem = {}
          this.selectedTaskId = ''
          this.tableKey = 0
          this.whtAmount = '0'
          this.selectedProjectId = ''
          this.typeOfBallance = 'primary',

          this.form.amount = ''
          this.form.paymentMethodId =''
          this.form.vendorListId = ''
          this.nativeAmount = ''

          this.disabledInputs = true,
          this.disabledTask =true
          this.fromExpensePage = false
          this.ifEdit = false
          this.projectTaskExpenseId = ''
          this.fileListEdit = []
          this.projectTaxId = ''
          this.isEmpty = false
          this.taxObject = ''
      },
      openModal(state){
        const urlParts = this.buildUrl(state)
        this.labelName = urlParts.labelName
        this.activeState = state
        this.getActiveProject(this.$route.query.projectId || this.$route.query.engagementId || this.$route.query.businessUnitId, state)
        let loader = this.$loading.show();
        console.log('urlParts', urlParts)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.state}/directories?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.$route.query.projectId || this.$route.query.engagementId || this.$route.query.businessUnitId}&${urlParts.stateTaskId}=${this.selectedRow.id}&operation=create`)
          .then(response => {
            console.log('---', response.data);
            if(this.selectedRow.type === 'project' || this.selectedRow.type === 'Engagement'){
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/${urlParts.stateProjectTasks}/list?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.$route.query.projectId || this.$route.query.engagementId || this.$route.query.businessUnitId}`).then(response => {
                this.form.taskList = response.data.list
                loader.hide()
              }).catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
            }
            // this.getCurrency()
            this.form.paymentMethodList = response.data.projectTaskExpensePaymentMethod
            this.form.companyInventoryItem = response.data.companyInventoryItem
            this.form.clientList = response.data.companyClientList
            // this.form.vendorList = response.data.companyVendorList
            this.links = response.data.companyVendorList
            this.form.taxList = response.data.projectTaxList
            this.disabledInputs = false
            this.$refs.projectExpenseModal.open();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      getActiveProject(projectId, state){
        const urlParts = this.buildUrl(state)
        axios
          .post(`/api/v1/${urlParts.routeName}/item?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
          .then(response => {
            this.selectedProject = response.data.item
          }).catch(error => {
          console.log('An error occurred:', error);
        });
      },
      submitForm(form, state) {
        const urlParts = this.buildUrl(state)
        this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.paymentMethodRadio === 'Payment'){
              this.form.cashAdvanceId = null
            }else if(this.paymentMethodRadio === 'CA'){
              this.form.paymentMethodId = null
            }
            let data = {
              projectTaskExpenseInventoryItemId: this.form.companyInventoryItemId,
              projectTaskExpensePaymentMethodId: this.form.paymentMethodId,
              companyVendorId: this.form.vendorListId,
              companyClientId: this.form.clientId,
              expenseDate: this.form.date,
              amount: Number(this.form.amount),
              totalAmount: this.totalAmaunt,
              taxAmount: Number(this.taxOf) || null,
              projectTaxId: this.form.taxId,
              includeTax: "0",
              reimbursable: this.form.reimbursable,
              vendorTaxNo: this.form.vendorTaxNumber,
              group: this.form.groupTripName,
              notes: this.form.notes,
              isBillable: this.form.billable,
              fileId: this.form.fileId,
              projectTaskCashAdvanceId: this.form.cashAdvanceId || null
            }
            if(state === 'engagementTaskExpenses'){
                data['engagementCashAdvanceId'] = data['projectTaskCashAdvanceId'];
                delete data['projectTaskCashAdvanceId'];
            }else if(state === 'engagementTaskExpenses'){
              data['businessUnitCashAdvanceId'] = data['projectTaskCashAdvanceId'];
              delete data['projectTaskCashAdvanceId'];
            }

            if(this.form.ifTax === 'Tax Inclusive'){
              data.includeTax = false
            }else if(this.form.ifTax === 'Tax Exclusive'){
              data.includeTax = true
            }
            let taskId = 0
            if(this.selectedRow.type === 'project'){
              taskId = this.form.taskListId
            }else{
              taskId = this.$route.query.taskId
            }



            let projectId = ''
            if(this.$route.name === 'expenses' || this.$route.name === 'users'){
              projectId = this.selectedProjectId
            }else if(this.$route.name === 'projects'){
              projectId = this.$route.query.projectId
            }else if(this.$route.name === 'engagements'){
              projectId = this.$route.query.engagementId
            }else if(this.$route.name === 'business-units'){
              projectId = this.$route.query.businessUnitId
            }


            //Ask if values of item not equal
            if(Number(this.nativeAmount) !== Number(this.form.amount) && this.isNativeSelected){
              this.$confirm('Are you sure you want to change buying price of Item?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'info'
              }).then(() => {
                this.updateItem(this.selectedItem, this.form.amount)
                this.sendRequestCreate(data, urlParts, projectId, taskId)
              }).catch(err => {
                console.log(err)
                return
              });
            }else{
              this.sendRequestCreate(data, urlParts, projectId, taskId)
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      sendRequestCreate(data, urlParts, projectId, taskId){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.state}/create?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}&${urlParts.stateTaskId}=${taskId || this.form.taskListId || 0}`, data)
          .then(response => {
            if(this.$route.name === 'expenses'){
              this.$emit('setValueProject', this.form.projectListId);
            }else if(this.$route.name === 'users'){
              this.$emit('refreshUserPage', this.form.projectListId)
            }
            this.$refs.projectExpenseModal.close();
            this.notification("Success", "Added Task Expense", "success");
          }).catch(error => {
          console.log('An error occurred:', error);
        });
      },
      updateItem(item, buyPrice){
        let data = {
          categoryId: item.categoryId,
          inventoryId: item.inventoryId,
          number: item.number,
          name: item.name,
          description: item.description,

          // selling
          sellPrice: item.sellPrice,
          projectTaxId: item.projectTaxId,
          withholdingTaxId: item.withholdingTaxId,
          companyChartOfAccountItemId: item.companyChartOfAccountItemId,
          sAllocatedTo2: item.sAllocatedTo2,
          sellerDecription: item.sellerDecription,

          // buying
          vendorId: item.vendorId,
          buyPrice: buyPrice,
          buyerProjectTaxId: item.buyerProjectTaxId,
          buyerWithholdingTaxId: item.buyerWithholdingTaxId,
          buyerCompanyChartOfAccountItemId: item.buyerCompanyChartOfAccountItemId,
          buyerDecription: item.buyerDecription,
          vendorItemCode: item.vendorItemCode,

          unitId: item.unitId,
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyInventoryItems/update?companyId=${this.$route.query.companyId}&companyInventoryItemId=${item.id}`, data)
          .then(response => {
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      submitFormEdit(form, state) {
        const urlParts = this.buildUrl(state)
        this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.paymentMethodRadio === 'Payment'){
              this.form.cashAdvanceId = null
            }else if(this.paymentMethodRadio === 'CA'){
              this.form.paymentMethodId = null
            }
            let data = {
              projectTaskExpenseInventoryItemId: this.form.companyInventoryItemId,
              projectTaskExpensePaymentMethodId: this.form.paymentMethodId,
              companyVendorId: this.form.vendorListId,
              companyClientId: this.form.clientId,
              expenseDate: this.form.date,
              amount: Number(this.form.amount),
              totalAmount: this.totalAmaunt,
              taxAmount: this.taxOf,
              projectTaxId: this.form.taxId,
              projectTaskId: this.form.taskListIdEdit,
              includeTax: "0",
              reimbursable: this.form.reimbursable,
              vendorTaxNo: this.form.vendorTaxNumber,
              group: this.form.groupTripName,
              notes: this.form.notes,
              isBillable: this.form.billable,
              fileId: this.form.fileId,
              projectTaskCashAdvanceId: this.form.cashAdvanceId
            }
            if(!data.fileId){
              data.fileId = null
            }
            if(this.form.ifTax === 'Tax Inclusive'){
              data.includeTax = false
            }else if(this.form.ifTax === 'Tax Exclusive'){
              data.includeTax = true
            }
            if(state === 'engagementTaskExpenses'){
              data['engagementCashAdvanceId'] = data['projectTaskCashAdvanceId'];
              data['engagementTaskId'] = data['projectTaskId'];
              delete data['projectTaskCashAdvanceId'];
              delete data['projectTaskId'];
            }else if(state === 'engagementTaskExpenses'){
              data['businessUnitCashAdvanceId'] = data['projectTaskCashAdvanceId'];
              data['businessUnitTaskId'] = data['projectTaskId'];
              delete data['projectTaskCashAdvanceId'];
              delete data['projectTaskId'];
            }

            let projectId = ''
            if(this.$route.name === 'expenses' || this.$route.name === 'users'){
              projectId = this.selectedProjectId
            }else{
              projectId = this.$route.query.projectId
            }

            //Ask if values of item not equal
            if(Number(this.nativeAmount) !== Number(this.form.amount) && this.isNativeSelected){
              this.$confirm('Are you sure you want to change buying price of Item?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'info'
              }).then(() => {
                this.updateItem(this.selectedItem, this.form.amount)
                this.sendRequestUpdate(data, urlParts, projectId)
              }).catch(() => {
                return
              });
            }else{
              this.sendRequestUpdate(data, urlParts, projectId)
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      sendRequestUpdate(data, urlParts, projectId){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.state}/update?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}&${urlParts.stateTaskId}=${this.form.taskListIdEdit || 0}&${urlParts.stateExpenseId}=${this.projectTaskExpenseId}`, data)
          .then(response => {
            if(this.$route.name === 'expenses'){
              this.$emit('setValueProject', this.selectedProjectId);
            }else if(this.$route.name === 'users'){
              this.$emit('refreshUserPage', this.selectedProjectId)
            }
            this.$refs.projectExpenseModal.close();
            this.notification("Success", "Edit Expense", "success");
          }).catch(error => {
          console.log('An error occurred:', error);
        });
      },
      nestedChildOpen(url){
        this.fileUrl = url
        this.$refs.nestedChild.open();
        // alert(url)
      },
      removeFile(url){
        // this.form.fileId.splice(url, 1)
        this.form.fileId = ''
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      buildUrl(state) {
        let routeName = ''
        let labelName = ''
        let stateProjectId = ''
        let projectId = ''
        let stateTaskId = ''
        let taskId = ''
        let stateExpenseId = ''
        let stateProjectTasks = ''
        switch (state){
          case 'projectTaskExpenses':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateProjectTasks = 'projectTasks'
            stateTaskId = 'projectTaskId'
            stateExpenseId = 'projectTaskExpenseId'
            break;
          case 'engagementTaskExpenses':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskExpenseId'
            labelName = 'Engagement'
            break;
          case 'businessUnitTaskExpenses':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTasks = 'businessUnitTasks'
            stateExpenseId = 'businessUnitTaskExpenseId'
            labelName = 'Business Unit'
            break;
          case 'requestProjectTaskExpenses':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateProjectTasks = 'projectTasks'
            stateExpenseId = 'projectTaskExpenseId'
            break;
          case 'requestEngagementTaskExpenses':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskExpenseId'
            labelName = 'Engagement'
            break;
          case 'requestBusinessUnitTaskExpenses':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateProjectTasks = 'businessUnitTasks'
            stateTaskId = 'businessUnitTaskId'
            stateExpenseId = 'businessUnitTaskExpenseId'
            labelName = 'Business Unit'
            break;
        }
        return {
          state: state,
          routeName: routeName,
          stateProjectId: stateProjectId,
          labelName: labelName,
          projectId: projectId,
          stateTaskId: stateTaskId,
          stateProjectTasks: stateProjectTasks,
          taskId: taskId,
          stateExpenseId: stateExpenseId}
      }
    }
  }
</script>

<style lang="scss" scoped>
    .project-expense-modal {
        &__title {
            text-align: center;
        }
        &__btn {
            text-align: center;
        }
        .form-row{
            display:flex;
            justify-content:space-around;
        }
        &__form{

        }
        .el-form-item {
            margin-bottom: 10px;
        }
        /deep/.el-form-item__label{
            line-height:18px;
        }
        /deep/.el-form-item__content{
            line-height:18px;
        }
        /*.el-select {*/
            /*display: block;*/
        /*}*/
        .el-date-editor{
            width:100%;
        }
        /*.inclusive-btn{*/
            /*margin-bottom:18px;*/
        /*}*/
        /deep/.el-input.is-disabled .el-input__inner{
            color: #404348;
        }
    }
    .amount-input{
        /deep/.el-input__inner{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
    }
    .amount-currency{
        /deep/.el-input__inner{
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
    .iframe{
        width:640px;
        height:700px;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
        .sweet-modal {
            max-width: 900px !important;
        }
    }
    /deep/.el-autocomplete{
        width:100%;
        .el-input-group__append{
            background-color: #ecf5ff;
            color: #409EFF;
            border-color: #b3d8ff;
            &:hover{
                background: #409EFF;
                border-color: #409EFF;
                color: #FFF;
            }
        }
        /*.el-input__suffix{*/
            /*right:0;*/
            /*.add-btn{*/

            /*}*/
            /*i{*/
                /*display:none;*/
            /*}*/
        /*}*/
    }
    .col{
        margin-left:50%;
    }
    .bill{
        text-align:right;
        h4{
        line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
    .my-autocompleteItem {
        li {
            line-height: normal;
            padding: 7px;

            .value {
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .link {
                font-size: 12px;
                color: #b4b4b4;
            }
        }
    }
</style>

<style>

</style>
